module.exports = __webpack_public_path__ + "img/a2b7c7c.jpg";